import { render, staticRenderFns } from "./TermsPicker.vue?vue&type=template&id=094903ee&"
import script from "./TermsPicker.vue?vue&type=script&lang=ts&"
export * from "./TermsPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports